import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-99d0837a")

_pushScopeId("data-v-99d0837a")
const _hoisted_1 = {
  class: "toc_ui__checkItem_main",
  id: "checkItemMain"
}
const _hoisted_2 = {
  id: "KABatteryInfo",
  class: "toc_ui_entrustQuery_cont"
}
const _hoisted_3 = { class: "toc_ui_entrustQuery_item" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "toc_ui_entrustQuery_item_name" }, "电池检测", -1)
const _hoisted_5 = { class: "toc_ui_entrustQuery_item_right" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "toc_ui_entrustQuery_bottom" }, null, -1)
const _hoisted_7 = { class: "toc_ui_entrustQuery_item" }
const _hoisted_8 = { class: "toc_ui_entrustQuery_item_name" }
const _hoisted_9 = { class: "toc_ui_entrustQuery_item_right" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "toc_ui_entrustQuery_bottom" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_checkItem = _resolveComponent("checkItem")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.dataList, (item, index) => {
      return _withDirectives((_openBlock(), _createBlock("div", {
        key: item.itemCode
      }, [
        _createVNode(_component_checkItem, {
          renderData: item,
          dataIndex: index
        }, null, 8, ["renderData", "dataIndex"])
      ], 512)), [
        [_vShow, !_ctx.state.tocOnlyShowFlaw || (item.defectItemCount>0 && _ctx.state.tocOnlyShowFlaw)]
      ])
    }), 128)),
    _withDirectives(_createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", {
          class: "toc_ui_entrustQuery_top",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToView(_ctx.state.batteryData)))
        }, [
          _hoisted_4,
          _createVNode("span", _hoisted_5, [
            _createVNode("img", {
              class: "arrow",
              src: require("@/assets/tocZQY/arrowRight.png")
            }, null, 8, ["src"])
          ])
        ]),
        _hoisted_6
      ])
    ], 512), [
      [_vShow, JSON.stringify(_ctx.state.batteryData) !== '{}']
    ]),
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.queryModules, (item) => {
      return _withDirectives((_openBlock(), _createBlock("div", {
        id: item.code,
        class: "toc_ui_entrustQuery_cont",
        key: item.code
      }, [
        _createVNode("div", _hoisted_7, [
          _createVNode("div", {
            class: "toc_ui_entrustQuery_top",
            onClick: ($event: any) => (_ctx.goToView(item))
          }, [
            _createVNode("span", _hoisted_8, _toDisplayString(item.name), 1),
            _createVNode("span", _hoisted_9, [
              _createVNode("img", {
                class: "arrow",
                src: require("@/assets/tocZQY/arrowRight.png")
              }, null, 8, ["src"])
            ])
          ], 8, ["onClick"]),
          _hoisted_10
        ])
      ], 8, ["id"])), [
        [_vShow, !_ctx.state.tocOnlyShowFlaw]
      ])
    }), 128))
  ]))
})